// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"ec1dd638","703":"4e59d877"}[chunkId] + ".chunk.js";
};